import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ServiceTypeEnum from '../../../../Enums/ServiceTypeEnum';
import selectHelper from '../../../../Helpers/selectHelper';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import {
  inStoreOrOnlineOptionsArray,
  specialLocationsOptionsArray,
  locationTypeOptionsArray,
  pricingAspectsArray,
  directedPricingArray,
  kpisBehaviorArray,
  announcedOrUnannouncedArray,
  locationListSourceArray,
  pricingAuditDataCaptureMethodArray,
  timeConstraintsMaxLength,
} from './SharedConstants';

const auditsPages = [
  {
    label: 'Fieldwork Requirements',
    hide: (item) => item.TypeCode != ServiceTypeEnum.AuditsPricing && item.TypeCode != ServiceTypeEnum.PricingAudits,
    fields: [
      {
        fieldName: 'TimeConstraints',
        label: 'Visit Time Constraints (days/hours/etc)',
        className: 'col-12',
        type: InputTypesEnum.Text,
        maxLength: timeConstraintsMaxLength,
      },
      {
        fieldName: 'SpecialLocations',
        label: 'Select Special Locations if Applicable',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: specialLocationsOptionsArray,
      },
      {
        fieldName: 'LocationType',
        label: 'Location Type (select all that apply)',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: locationTypeOptionsArray,
      },
      {
        fieldName: 'LocationTypeDetails',
        label: 'Location Type Details',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
        hide: (item) => !item.LocationType || !item.LocationType.includes('Other'),
      },
      {
        fieldName: 'LocationListSource',
        label: 'Location List Source',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(locationListSourceArray.map((l) => l.label)),
      },
    ],
  },
  {
    label: 'Program Approach',
    hide: (item) => item.TypeCode != ServiceTypeEnum.AuditsPricing && item.TypeCode != ServiceTypeEnum.PricingAudits,
    fields: [
      {
        fieldName: 'InStoreOrOnline',
        label: 'In-store, Online, or Phone',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: inStoreOrOnlineOptionsArray,
      },
      {
        fieldName: 'NumLocations',
        label: 'Number of locations',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumItemsPricesPerLocation',
        label: 'Number of items/prices per location?',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'PriceAccuracySlarequired',
        label: 'Price accuracy SLA required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PriceAccuracySladescription',
        label: 'If yes, please describe',
        className: 'col-12',
        type: InputTypesEnum.Text,
        hide: (item) => item.PriceAccuracySlarequired == 'false' || item.PriceAccuracySlarequired == '',
      },
      {
        fieldName: 'CompetitorPricingStudy',
        label: 'Competitor pricing study?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'NumCompetitors',
        label: 'If yes, number of competitors',
        className: 'col-12',
        type: InputTypesEnum.Text,
        hide: (item) => item.CompetitorPricingStudy == 'false' || item.CompetitorPricingStudy == '',
      },
      {
        fieldName: 'AnnouncedOrUnannounced',
        label: 'Announced or Unannounced?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(announcedOrUnannouncedArray.map((a) => a.label)),
      },
      {
        fieldName: 'LetterOfAuthorizationRequired',
        label: 'Letter of Authorization Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PhotosReqd',
        label: 'Photos required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PhotosDescription',
        label: 'If yes, description of photos required',
        className: 'col-12',
        type: InputTypesEnum.Text,
        hide: (item) => item.PhotosReqd == 'false' || item.PhotosReqd == '',
      },
      {
        fieldName: 'UpcjanianscanRequired',
        label: 'UPC/JAN/IAN scan required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'NumDaysInField',
        label: 'Number of days in field?',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'PricingAspectsToEvaluate',
        label: 'What pricing aspects should be evaluated?',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: pricingAspectsArray,
      },
      {
        fieldName: 'ProductType',
        label: 'Product type',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'DirectedPricingApproach',
        label: 'Directed price gathering, category scanning, full store scanning, or other',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: directedPricingArray,
      },
      {
        fieldName: 'DirectedPricingApproachDetails',
        label: 'Other Directed Pricing Approach Details',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
        hide: (item) => !item.DirectedPricingApproach || !item.DirectedPricingApproach.includes('Other'),
      },
      {
        fieldName: 'DescriptionGatheringRequired',
        label: 'Description gathering required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'KpisBehaviorRequirements',
        label: "Any specific KPI's or behavior requirement?",
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: kpisBehaviorArray,
      },
    ],
  },
  {
    label: 'Purchase',
    hide: (item) => item.TypeCode != ServiceTypeEnum.AuditsPricing && item.TypeCode != ServiceTypeEnum.PricingAudits,
    fields: [
      {
        fieldName: 'PurchaseReqd',
        label: 'Purchase Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PurchaseAmtCurId',
        label: 'Purchase Amount Currency',
        className: 'col-12',
        type: InputTypesEnum.ActiveCurrencySelect,
      },
      {
        fieldName: 'PurchaseAmt',
        label: 'Minimum Purchase Amount',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'MaxPurchaseAmt',
        label: 'Maximum Purchase Amount',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'PurchaseDesc',
        label: 'Item Required to Be Purchased',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
    ],
  },
  {
    label: 'Visit Validation',
    hide: (item) => item.TypeCode != ServiceTypeEnum.AuditsPricing && item.TypeCode != ServiceTypeEnum.PricingAudits,
    fields: [
      {
        fieldName: 'NumPhotographsReqd',
        label: 'Number of Photographs Required',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'StorefrontPhotoRequired',
        label: 'Storefront Photo Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'GeoLocationTagging',
        label: 'GEO Location Tagging',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'OtherPhotosDesc',
        label: 'Describe other Photographs Required',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
    ],
  },
  {
    label: 'Data Capture Method',
    hide: (item) => item.TypeCode != ServiceTypeEnum.AuditsPricing && item.TypeCode != ServiceTypeEnum.PricingAudits,
    fields: [
      {
        fieldName: 'PricingAuditDataCaptureMethod',
        label: 'Data Capture Method',
        className: 'col-6',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(pricingAuditDataCaptureMethodArray.map((p) => p.label)),
        validityChecker: ValidityHelper.emptyValidityChecker,
      },
      {
        fieldName: 'OtherDataCaptureMethod',
        label: 'Other Data Capture Method Description',
        className: 'col-6',
        type: InputTypesEnum.Text,
        hide: (item) => item.PricingAuditDataCaptureMethod !== 'Other',
      },
    ],
  },
  {
    label: 'Auditor Demographics',
    hide: (item) => item.TypeCode != ServiceTypeEnum.AuditsPricing && item.TypeCode != ServiceTypeEnum.PricingAudits,
    fields: [
      {
        fieldName: 'MinAge',
        label: 'Minimum Age',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'MaxAge',
        label: 'Maximum Age',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'GenderCode',
        label: 'Gender',
        className: 'col-12',
        type: InputTypesEnum.CommonGenderLookupItemSelect,
      },
      {
        fieldName: 'OtherDemographicRequirements',
        label: 'Other Demographic Requirements',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
    ],
  },
];

export default auditsPages;
